const phoneRegex = /^\d{5,15}$/;

export default phoneRegex;
